import {
  useMutation,
  useQueryClient,
  type UseMutationOptions,
} from '@tanstack/react-query';
import { toast } from '@/shared/hooks/use-toast';
import type { CreatePresetPayload, PresetResponse } from '../types';
import { presetApi } from '../api';
import { presetKeys } from './preset.keys';

export type CreatePresetInput = Omit<CreatePresetPayload, 'cover' | 'lut'>;

export function useCreatePreset(
  options?: UseMutationOptions<PresetResponse, Error, CreatePresetInput>
) {
  const queryClient = useQueryClient();
  const { onSuccess: providedOnSuccess, onError: providedOnError, ...mutationOptions } = options ?? {};
  const mutation = useMutation({
    mutationKey: ['presets', 'create'],
    mutationFn: presetApi.create,
    ...mutationOptions,
    onSuccess: (data, variables, onMutateResult, context) => {
      toast({ title: 'Preset criado com sucesso', variant: 'success' });
      queryClient.invalidateQueries({ queryKey: presetKeys.all });
      providedOnSuccess?.(data, variables, onMutateResult, context);
    },
    onError: (error, variables, onMutateResult, context) => {
      toast({
        title: 'Erro ao criar preset',
        description: error.message,
        variant: 'destructive',
      });
      providedOnError?.(error, variables, onMutateResult, context);
    },
  });
  return {
    createPreset: mutation.mutateAsync,
    isLoading: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
    mutationResult: mutation,
  };
}
